@if (!isMaintenanceMode) {
  <router-outlet></router-outlet>
  <!-- <ng-content *ngIf = "! (isLoading | async); else indicator"> </ng-content>  -->
  @if (!isLoading) {
    <ng-content> </ng-content>
  } @else {
    <div class="indicator">
      <div>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }

  <div id="fab_wrap" (touchend)="onFabSwiper($event)" (touchstart)="onFabSwiper($event)">
    @if (userDeviceInfo === 'mobile') {
      <div class="fab-wrap" [class.show]="!isFab">
        <div class="fab-button">
          <div class="fab-icon" (click)="onClickCS()">
            <img src="/assets/images/{{ csFabSrc }}.svg" alt="" />
          </div>
          <div
            class="fab-icon"
            (click)="onClickBulkProducts()"
            [class.disabled]="
              productService.selectProducts.length === 0 ||
              ['/cart', '/order', '/order/select-gift', '/order/payment', '/order/complete'].includes(location.path())
            "
          >
            <img src="/assets/images/bag-outline.svg" alt="" />
            <!-- <div class="count">
            {{ productService.selectProducts.length }}
          </div> -->
          </div>
        </div>
        <button
          id="isShowHide"
          type="button"
          (click)="onFabPopup()"
          [class.show]="isFab"
          [class.is-open]="isFab"
          [class.is-closed]="!isFab"
          aria-label="Toggle floating buttons"
        >
          <i class="pi pi-chevron-right fab-toggle-icon" style="color: white" [class.rotated]="!isFab"></i>
        </button>
      </div>
    }
  </div>
}

@if (isMaintenanceMode) {
  <section class="maintenance-empty-page">
    <div class="maintenance-dim"></div>
    <div class="popup-content">
      <div class="popup-body">
        <img [src]="'/assets/images/maintance_popup.webp'" alt="maintenance" />
      </div>
    </div>
  </section>
}
